import { useEffect, Dispatch, SetStateAction } from 'react';

type Props = {
  value: string | string[];
  selectedObject: { [key: string]: string };
  setSelectedObject: Dispatch<SetStateAction<{ [key: string]: string }>>;
  indeterminate: boolean;
  setIndeterminate: Dispatch<SetStateAction<boolean>>;
  filteredOptions: { value: string; label: string }[];
  multiple?: boolean;
  onChange?: (value: string | string[]) => void;
};

const useHandleDropdownSelect = ({
  value,
  multiple,
  selectedObject,
  setSelectedObject,
  indeterminate,
  setIndeterminate,
  filteredOptions,
  onChange,
}: Props) => {
  useEffect(() => {
    if (multiple && value.length === 1 && value[0] === 'all') {
      setIndeterminate(false);
      onChange?.([]);
    } else if (
      multiple &&
      Array.isArray(value) &&
      value.includes('all') &&
      value.length === filteredOptions.length + 1
    ) {
      setIndeterminate(false);
      if (!value.includes('all')) {
        onChange?.([...value, 'all']);
      }
    }
  }, [filteredOptions, multiple, onChange, setIndeterminate, value]);

  const handleItemClick = (val: string) => {
    if (multiple) {
      if (val === 'all') {
        if ((value as string[]).includes('all')) {
          if (indeterminate) {
            setIndeterminate(false);
          }
          onChange?.([]);
          setSelectedObject({});
          return;
        }
        onChange?.([...filteredOptions.map((o) => o.value), 'all']);
        setIndeterminate(false);
        setSelectedObject(
          filteredOptions.reduce(
            (acc, curr) => ({
              ...acc,
              [curr.value]: true,
            }),
            {},
          ),
        );
        return;
      }
      if ((value as string[]).includes(val)) {
        if ((value as string[]).includes('all')) {
          setIndeterminate(true);
        } else {
          setIndeterminate(false);
        }

        onChange?.((value as string[]).filter((v) => v !== val));
      } else {
        onChange?.([...(value as string[]), val]);
      }

      setSelectedObject({
        ...(selectedObject as any),
        [val]: !selectedObject[val],
      });
    } else {
      onChange?.(val);
    }
  };

  return { handleItemClick };
};

export default useHandleDropdownSelect;
